import React, { Component } from 'react';
import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';


import { toggleAddProgrammePopup } from '../../redux/reducers/view';
import { getUserProgramsFullRequest,setUserRating, setUserRatingComment, setUserRatingVersion } from '../../redux/reducers/userProgramsFull';

import Popup from '../Popup';
import AddCodeForm from '../Form/AddCodeForm';

import { commonStyles, COLORS } from '../../styles/styles';
import addCodeKeyImage from '../../assets/add_code_key.svg';
import TextField from '@material-ui/core/TextField';


import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import StarRatings from 'react-star-ratings';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBIcon, MDBInput } from 'mdbreact';



import AvatarCirce from '../AvatarCircle';
import { xapiRequest } from '../../redux/reducers/xapi';


class UserRatingPopup extends Component{ 

  state = {
    modal: true
  };
  componentWillReceiveProps(nextProps){
    
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }
  render(){
    const {classes, 
      handleCloseNow, 
      styles,
      handlePopupToggle,
      changeRating,
      userRatingNow,
      handleSubmit, 
      setComment, 
    } = this.props 
    return (<MDBContainer>
              <MDBModal isOpen={this.state.modal} toggle={this.toggle}  centered  >
                <MDBModalHeader toggle={handlePopupToggle} className="default-color text-white">My Self Rating</MDBModalHeader>
                <MDBModalBody>
                <div style={{
                  marginBottom: 20,
                  height: 82,
                  border: '1 solid #f5c6cb',
                  backgroundColor: '#DC3146',textAlign:'center'}}>
                  <Typography style={{ 
                      height: 24,
                      color: '#FFF',
                      fontFamily: 'PT Sans',
                      fontSize: 45,
                      fontWeight: 900,
                      paddingTop: 20
                      }}>
                    {userRatingNow}/5
                  </Typography>
                </div>
                <Typography style={{ width: 240,
                height: 24,
                color: '#363636',
                fontFamily: 'PT Sans',
                fontSize: 16,
                fontWeight: 700,
                padding:10
                }}>
                    My confidence level
                </Typography>
                    <div style={{width:"100%", textAlign:'center', float:'left', marginTop:-17}} >
                      <StarRatings
                        rating={userRatingNow}
                        starRatedColor="#00A1E0"
                        starHoverColor='#00A1E0'
                        starEmptyColor = 'rgb(221,221,221)'
                        changeRating={changeRating}
                        numberOfStars={5}
                        name='rating'
                        starDimension="18px"
                      />
                      </div>
                      <div className="pt-3">
        <MDBInput type="textarea" label="Comments" background getValue={setComment}/>
        </div>
                      
                </MDBModalBody>
                <MDBModalFooter>
                  <MDBBtn size="sm" className="btn-dark-green" color={'success'} onClick={handleSubmit}>Save &amp; Submit</MDBBtn>
                </MDBModalFooter>

              </MDBModal>
            </MDBContainer>
    )
    }
  }
 
  


const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
  senderAvatar: {
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 500,
    color: '#50E3C2',
    flexShrink: 0,
    marginRight: 7,
    backgroundColor: '#4A4A4A',
    width: `70px`,
    height: `70px`,
  },

});
const mapDispatchToProps = dispatch => ({
  toggleAddProgrammePopup: value => dispatch(toggleAddProgrammePopup(value)),
  setUserRating: (int) => dispatch(setUserRating(int)),
  setUserRatingComment: (string) => dispatch(setUserRatingComment(string)),
  setUserRatingVersion: (int) => dispatch(setUserRatingVersion(int)),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
});
const mapStateToProps = state => ({
  
  userRatingNow: state.userProgramsFullReducer.userRating,
  userRatingApi: state.userRatingReducer,
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    
    changeRating: props => ( newRating, name ) =>{
      props.setUserRating(newRating)
    },
    handleSubmit:props => () => {
      props.xapiRequest({ xapiType: `Submitted`});
     // props.setUserRatingComment('hello');
      props.handleAPISubmit();
    }

  }),
  lifecycle({
    componentWillMount(){
      this.props.setUserRating(0)
      this.props.setComment('Comment');
    }
   
  }),
  withStyles(styles),
)(UserRatingPopup);

UserRatingPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  toggleAddProgrammePopup: PropTypes.func,
};
